export default function getVariation(placement) {
  return placement.split('-')[1];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@popperjs/core/lib/utils/getVariation.js
// module id = 47
// module chunks = 0